import React from 'react';

const Services = () => {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-center text-royal-blue mb-6">Our Services</h1>
      <p className="text-lg text-gray-700 text-center mb-8">
        At Ekul Consulting, we offer a wide range of recruitment and HR solutions tailored to meet the unique needs of businesses and job seekers alike.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="bg-light-green p-4 rounded-lg shadow-md text-center">
          <img src="https://via.placeholder.com/300x200?text=Healthcare" alt="Healthcare" className="w-full h-32 object-cover mb-2" />
          <h3 className="text-xl font-bold text-royal-blue mb-2">Healthcare Recruitment</h3>
          <p className="text-gray-700">Connect skilled healthcare professionals with top institutions.</p>
        </div>
        {/* Repeat for other services */}
      </div>
    </div>
  );
};

export default Services;